// @flow

import type { State as GlobalState } from '../../types';

import {
  getModel,
  getMake,
  getFueltype,
  getPower,
  getEngine,
  getShortestDeliveryTime,
  getDefaultMileageValue,
  getDefaultDurationValue,
  getActivePdbId,
  getDiscountPrice,
} from '../../pdb';
import { getPathname } from '../../router';

type CarImpressionType = {
  id: string,
  name: string,
  brand: string,
  variant?: string,
  delivery: number,
  mileage: number,
  duration: number,
  position: number,
};

export const getImpressionPosition = (
  state: GlobalState,
  pdbId?: ?string,
): number => {
  const impressionPositions = state.gtm.impressionPositions[getPathname(state)];
  if (!impressionPositions || !impressionPositions.includes(pdbId)) {
    return 0;
  }
  return impressionPositions.indexOf(pdbId);
};

export const getImpressionIdsByPage = (
  state: GlobalState,
): Array<string> => (
  state.gtm.impressionPositions[getPathname(state)] || []
);

export const getImpression = (
  state: GlobalState,
  pdbId?: ?string,
): CarImpressionType => {
  const id = pdbId || getActivePdbId(state) || '0';
  const variant = `${getEngine(state)} ${getPower(state)} ${getFueltype(state, id)}`;
  const name = getModel(state, id);
  const brand = getMake(state, id);
  const duration = parseInt(getDefaultDurationValue(state) || '0', 10);
  const mileage = parseInt(getDefaultMileageValue(state) || '0', 10);
  const delivery = getShortestDeliveryTime(state, id);
  const position = getImpressionPosition(state, id);
  const price = getDiscountPrice(state, id);

  return {
    id,
    name,
    brand,
    variant,
    delivery,
    duration,
    mileage,
    position,
    price,
  };
};

export default null;
